import { useState } from "react";
import Server from "../api/Server";
import { formatConfigData } from "../utils";
import notify from "devextreme/ui/notify";

const useFetchConfig = (warahouses, registers, allUsers) => {
  const [configData, setConfig] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchConfigData = async (params, baseURL, keys, isUpdate) => {
    if (!isUpdate) {
      setIsLoading(true);
    }

    try {
      const { data } = await Server.getAccountConfig(params, baseURL, keys);

      if (data && data.length) {
        setConfig(formatConfigData(data, warahouses, registers, allUsers));
      } else {
        setConfig([]);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setConfig([]);
      const {
        response: { data },
      } = error;

      if (data) {
        notify(`${data.message}`, "error", 3000);
      } else {
        notify(`Error performing operation`, "error", 3000);
      }
    }
  };

  return {
    configData,
    isLoading,
    fetchConfigData,
  };
};

export default useFetchConfig;
